import { useQuery } from '@tanstack/react-query';
import { getDashboardSystemProblems } from '../api/systemProblems.api';
import { queryKeys } from '../api/queryKeys';

/**
 * How many system problems are open - the sidebar badge.
 *
 * The same query (and cache entry) as the Dashboard card's All chip, so the
 * admin app's `useSystemProblemsSocket` refreshes this number along with the
 * page and the Orders tab's urgent bar.
 */
export function useSystemProblemsOpenCount({ enabled = true } = {}) {
  const query = useQuery({
    queryKey: queryKeys.systemProblems.dashboardFor(null),
    queryFn: async () => {
      const { data } = await getDashboardSystemProblems({ category: null });
      return data.data;
    },
    enabled,
  });

  return { open: query.data?.open ?? 0 };
}
